export enum ProductIncludes {
  relatedProducts = 'relatedProducts',
  relatedRecipes = 'relatedRecipes',
  moreRecipes = 'moreRecipes',
}

export enum AddressTypes {
  SHIPPING = 'shipping',
  BILLING = 'billing',
}

export enum SubscriptionItemActions {
  ADD = 'add',
  REMOVE = 'remove',
  MORE = 'more',
  LESS = 'less',
}

export enum SubscriptionActions {
  ALIAS = 'alias',
  ARCHIVE = 'archive',
  CANCEL = 'cancel',
  CONFIRM = 'confirm',
  PAUSE = 'pause',
  RESUME = 'resume',
  ADD_ITEM = 'addItem',
  ACTIVATE_SUBSCRIPTION = 'activateSubscription',
  CHANGE_DATE_FREQUENCY = 'changeDateFrequency',
  CONFIRM_ACTION = 'confirmAction',
  UPDATE_SHIPPING_COST = 'updateShippingCost',
}

export enum SubscriptionAlerts {
  NO_ADDRESS = 'A shipping and billing address must be added to all active subscriptions to ensure your order arrives at your door. To add a new address or edit an existing address, go to the Address section in My Account.',
}

export enum BCShippingZones {
  ZIP = 'zip',
  COUNTRY = 'country',
  STATE = 'state',
  GLOBAL = 'global',
}

export enum BCShippingMethods {
  PER_ORDER = 'perorder',
  PER_ITEM = 'peritem',
  WEIGHT = 'weight',
  TOTAL = 'total',
  PICKUP_IN_STORE = 'pickupinstore',
}

export const SUBSCRIPTION_MODAL = {
  ADD_ITEM: {
    ITEMS_PER_PAGE: 4,
  },
};

export const REVALIDATION_TIME = {
  SHORTER: 10, // 10 seconds
  SHORT: 60, // 1 minute
  MEDIUM: 300, // 5 minutes
  LONG: 600, // 10 minutes
  LONGER: 1800, // 30 minutes
};
